import React from 'react'

import OmrQuestionSheet from '@components/OMR'

export type AsideProps = {
  goToQuestion: (num: number) => void
  isDelivery?: boolean
}

const Aside: React.FC<AsideProps> = (props) => {
  return (
    <div
      className={
        'flex-none border-l border-cbtLayout w-[280px] hidden lg:block overflow-auto max-h-full'
      }
    >
      <div className={'h-full bg-white'}>
        <div className={'bg-_263856'}>
          <h3 className={'text-white text-center text-2xl font-bold h-[72px] leading-[72px]'}>
            답안 표기란
          </h3>
        </div>
        <div className={'h-[calc(100%-72px)] overflow-y-auto'}>
          <OmrQuestionSheet {...props} />
        </div>
      </div>
    </div>
  )
}

export default Aside
